// Models
import { SearchActionTypes } from 'app/modules/search/models';
import { U21SelectOptionProps } from 'app/shared/u21-ui/components';

import { createSelector } from 'reselect';

import { IconUsers } from '@u21/tabler-icons';

export const selectEntitiesSearchResults = (state: RootState) => {
  return (
    state.search.entities || {
      data: [],
    }
  );
};

export const selectTeamSearchResults = (state: RootState) => {
  return (
    state.search.teams || {
      data: [],
    }
  );
};

export const selectTeamOptions = createSelector(
  selectTeamSearchResults,
  (teams): U21SelectOptionProps[] =>
    teams.data.map((i) => ({
      icon: <IconUsers />,
      text: i.name,
      value: i.id,
    })),
);

export const selectTxnEventsSearchResults = (state: RootState) => {
  return (
    state.search.txnEvents || {
      data: [],
    }
  );
};

export const selectActionEventsSearchResults = (state: RootState) =>
  state.searchSlice.actionEvents || {
    data: [],
  };

// Loading
export const selectEntitiesSearchLoading = (state: RootState) =>
  Boolean(state.loading[SearchActionTypes.ENTITIES_SEARCH]);

export const selectTxnEventsSearchLoading = (state: RootState) =>
  Boolean(state.loading[SearchActionTypes.TXN_EVENTS_SEARCH]);

export const selectActionEventsSearchLoading = (state: RootState) =>
  Boolean(state.searchSlice.actionEventsLoading);
